import { useSelector } from "react-redux";
import type { IStockState } from "../data/types";


const selectIStockServer = (state: IStockState) => (state.widgetConfig.istockServer);
export const useIStockServer = () => useSelector(selectIStockServer);
